import React from 'react'
import classNames from 'classnames'
import type { TApplyingFinancingAgentFormStepProps } from '@/components/composed/landingBlocks/LandingApplyingOfferFormNew/types'
import { Button, GlassMorphIcon } from '@/components/ui'
import { messages } from './messages'
import './styles.scss'

const ApplyingFinancingAgentFail: React.FC<TApplyingFinancingAgentFormStepProps> = ({ className, onReset }) => {
  return (
    <div className={classNames(className, 'applyingFinancingAgentSuccess')}>
      <GlassMorphIcon image="red/info" className="modal-content__headerIcon" />
      <div className="applyingFinancingAgentSuccess__container_text">
        <h3>{messages.text.title}</h3>
        <span>{messages.text.description}</span>
      </div>
      <div className="applyingFinancingAgentSuccess__buttons">
        <Button onClick={onReset} type="submit" modifiers={['green', 'full-width-mobile']}>
          {messages.buttons.close}
        </Button>
      </div>
    </div>
  )
}

export default ApplyingFinancingAgentFail
